export enum LogSourceLevel {
  Start,
  BeforeBusinessLogic,
  AfterBusinessLogic,
  End,
}
